import { _ as o } from "./_asciiToArray.js";
import { _ as a } from "./_hasUnicode.js";
import { _ as i } from "./_unicodeToArray.js";
var s = o, _ = a, c = i;
function n(r) {
  return _(r) ? c(r) : s(r);
}
var y = n;
export {
  y as _
};
//# sourceMappingURL=_stringToArray.js.map
